import { Typography, Space } from 'antd';
import type { ReactNode } from 'react';
import { neutral } from '@/theme';

const { Title, Text } = Typography;

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  extra?: ReactNode;
}

export function PageHeader({ title, subtitle, extra }: PageHeaderProps) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 24,
        paddingBottom: 16,
        borderBottom: `1px solid ${neutral[100]}`,
      }}
    >
      <Space direction="vertical" size={4}>
        <Title level={3} style={{ margin: 0, fontWeight: 700, letterSpacing: '-0.5px' }}>
          {title}
        </Title>
        {subtitle && (
          <Text style={{ color: neutral[500], fontSize: 14 }}>
            {subtitle}
          </Text>
        )}
      </Space>
      {extra && <Space>{extra}</Space>}
    </div>
  );
}
